/* eslint-disable */
import { withStyles } from '@material-ui/core';
import { ImplicitCallback, Security } from '@okta/okta-react';
import * as Sentry from '@sentry/browser';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import MuiPickersUtilsProvider from 'material-ui-pickers/MuiPickersUtilsProvider';
import React from 'react';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import compose from 'recompose/compose';
import PrivateRoute from '../../Components/PrivateRoute/PrivateRoute.component';
import AccountPage from '../../Pages/Account/Account.page';
import { ACCOUNT_PAGE_PATH } from '../../Pages/Account/Account.page.route';
import AccountsPage from '../../Pages/Accounts/Accounts.page';
import { ACCOUNTS_PAGE_PATH } from '../../Pages/Accounts/Accounts.page.route';
import AdminPage from '../../Pages/Admin/Admin.page';
import { ADMIN_PAGE_PATH } from '../../Pages/Admin/Admin.page.route';
import DashboardPage from '../../Pages/Dashboard/Dashboard.page';
import DocketsPage from '../../Pages/Dockets/Dockets.page';
import { DOCKETS_PAGE_PATH } from '../../Pages/Dockets/Dockets.page.route';
import ErrorPage from '../../Pages/Error/Error.page';
import { ERROR_PAGE_PATH } from '../../Pages/Error/Error.page.route';
import HelpPage from '../../Pages/Help/Help.page';
import { HELP_PAGE_PATH } from '../../Pages/Help/Help.page.route';
import { HOME_PAGE_PATH, INDEX_PAGE_PATH_REDIRECT } from '../../Pages/Home/Home.page.route';
import LayoutTemplate1 from '../../Pages/LayoutTemplate1/LayoutTemplate1.page';
import LayoutTemplate2 from '../../Pages/LayoutTemplate2/LayoutTemplate2.page';
import LayoutTemplate3 from '../../Pages/LayoutTemplate3/LayoutTemplate3.page';
import LoginPage from '../../Pages/Login/Login.page';
import { LOGIN_PAGE_PATH } from '../../Pages/Login/Login.page.route';
import LogoutPage from '../../Pages/Logout/Logout.page';
import { LOGOUT_PAGE_PATH } from '../../Pages/Logout/Logout.page.route';
import OrderPage from '../../Pages/Order/Order.page';
import { ORDER_PAGE_PATH, ORDER_PLURAL_PAGE_REDIRECT } from '../../Pages/Order/Order.page.route';
import OrderConcreteDeliveriesPage from '../../Pages/OrderConcreteDeliveries/OrderConcreteDeliveries.page';
import {
  ORDER_CONCRETE_DELIVERIES_PAGE_PATH,
  ORDER_CONCRETE_DELIVERIES_PLURAL_PAGE_REDIRECT,
} from '../../Pages/OrderConcreteDeliveries/OrderConcreteDeliveries.page.route';
import OrdersPage from '../../Pages/Orders/Orders.page';
import { ORDERS_PAGE_PATH } from '../../Pages/Orders/Orders.page.route';
import PlaceOrderPage from '../../Pages/PlaceOrder/PlaceOrder.page';
import { PLACE_ORDER_PAGE_PATH } from '../../Pages/PlaceOrder/PlaceOrder.page.route';
import ProfilePage from '../../Pages/Profile/Profile.page';
import { PROFILE_PAGE_PATH } from '../../Pages/Profile/Profile.page.route';
import ReportPage from '../../Pages/Report/Report.page';
import { REPORT_PAGE_PATH } from '../../Pages/Report/Report.page.route';
import ReportsPage from '../../Pages/Reports/Reports.page';
import { REPORTS_PAGE_PATH } from '../../Pages/Reports/Reports.page.route';
import SettingsPage from '../../Pages/Settings/Settings.page';
import { SETTINGS_PAGE_PATH } from '../../Pages/Settings/Settings.page.route';
import TermsPage from '../../Pages/Terms/Terms.page';
import { TERMS_CONDITIONS_PAGE_PATH } from '../../Pages/Terms/Terms.page.route';
import registerServiceWorker from '../../registerServiceWorker';
import browserHistory from '../../State/History/Browser.history';
import envGet from '../../Support/Env/Get/EnvGet.support';
import httpStatus from '../../Support/Http/Status/HttpStatus.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import App from '../App';
import PortalCustomerEntryPropTypes from './PortalCustomer.entry.props';
import portalCustomerServices from './PortalCustomer.entry.services';
import portalCustomerEntry from './PortalCustomer.entry.shape';
import MaintenancePage from '../../Components/MaintenancePage/MaintenancePage.component';
import BrowserNotSupported from '../../Components/BrowserNotSupported/BrowserNotSupported.component';
import * as Bowser from 'bowser';

const clientId = envGet({ key: `REACT_APP_ENTRY_PORTAL_CUSTOMER_OKTA_CLIENT_ID` });
const issuer = envGet({ key: `REACT_APP_ENTRY_PORTAL_CUSTOMER_OKTA_ISSUER` });
const redirectUriLink = envGet({ key: `REACT_APP_ENTRY_PORTAL_CUSTOMER_OKTA_REDIRECT_URI` });
const baseUrl = envGet({ key: `REACT_APP_ENTRY_PORTAL_CUSTOMER_OKTA_BASE_URL` });
const showMaintenancePage = envGet({ key: `REACT_APP_BORAL_FEATURE_TOGGLE_SHOW_MAINTENANCE_PAGE` }) === `true`;

/**
 * PortalCustomerEntryComponent
 * @export
 * @class PortalCustomerEntryComponent
 * @extends {React.Component<PortalCustomerEntryComponentComposedProps, PortalCustomerEntryComponentState>}
 */
export class PortalCustomerEntryComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<PortalCustomerEntryComponentProps>}
   * @memberof PortalCustomerEntryComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`PortalCustomer`}
   * @memberof PortalCustomerEntryComponent
   */
  static displayName = `PortalCustomer`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof PortalCustomerEntryComponent
   */
  static propTypes = PortalCustomerEntryPropTypes;

  /**
   * Data specific to the `<PortalCustomerEntryComponent />` instance
   * @type {PortalCustomerEntryComponentState}
   * @memberof PortalCustomerEntryComponent
   */
  state = {};

  /**
   * When the Component mounts, update it
   * @returns {void} void
   * @memberof AccountsPageComponent
   */
  componentDidMount() {
    const { authService } = portalCustomerServices;

    /**
     * Workaround fix to do with https://boraldigitalsolutions.atlassian.net/browse/CX-3169
     * GitHub issue can be found here - https://github.com/okta/okta-auth-js/issues/215
     * Better fix would be to have cache error handing on the API levels
     */
    const xhr = new XMLHttpRequest();
    if (`withCredentials` in xhr) {
      xhr.addEventListener(`load`, () => {
        if ({}.hasOwnProperty.call(JSON.parse(xhr.response), `errorCode`) || xhr.response === `undefined`) {
          window.localStorage.removeItem(`bds:auth`);
          window.localStorage.removeItem(`okta-cache-storage`);
          window.localStorage.removeItem(`okta-token-storage`);
          // authService.logout();
        }
      });
      xhr.open(`GET`, `${baseUrl}/api/v1/sessions/me`, true);
      xhr.withCredentials = true;
      xhr.send();
    } else {
      Sentry.captureMessage(`CORS is not supported for this browser.`);
      return ``;
    }
  }

  /**
   * Check if browser is supported
   * @returns {false} if browser is supported
   * @memberof PortalCustomerEntryComponent
   */
  browserSupported() {
    const browser = Bowser.getParser(window.navigator.userAgent);

    // based on https://boraldigitalsolutions.atlassian.net/wiki/spaces/CX/pages/1333854281/Browser+Support+Test+Devices
    const isValidBrowser = browser.satisfies({
      ios: {
        safari: '>=12',
      },
      macos: {
        safari: '>=13',
      },
      windows: {
        firefox: '>=86',
        edge: '>=89',
      },
      chrome: '>=87',
      samsung_internet: '>=12'
    });

    return !!isValidBrowser;
  }

  /**
   * Render Admin routes
   * @param {any} props The route props
   * @returns {React.Component} PortalCustomerEntryComponent
   * @memberof PortalCustomerEntryComponent
   */
  renderAdminRoutes({ match }) {
    return (
      <Switch>
        <PrivateRoute exact path={`${match.url}`} render={() => <AdminPage />} />
        <PrivateRoute path={`${match.url}/upload`} render={() => <AdminPage />} />
        <PrivateRoute render={() => <ErrorPage status={httpStatus.NOT_FOUND} />} />
      </Switch>
    );
  }

  /**
   * Render Okta routes
   * @returns {React.Component} PortalCustomerEntryComponent
   * @memberof PortalCustomerEntryComponent
   */
  renderOktaRoutes() {
    // const appSW = registerServiceWorker();
    const appSW = null
    const redirectUri = `${window.location.origin}/implicit${redirectUriLink}`;
    const { authService } = portalCustomerServices;
    const { classes } = this.props;
    if (!this.browserSupported()) {
      return <BrowserNotSupported />;
    }
    return showMaintenancePage ? (
      <MaintenancePage />
    ) : (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <Router history={browserHistory}>
          <Security
            className={classes.fullHeight}
            client_id={clientId}
            issuer={issuer}
            onAuthRequired={(history) => history.push(LOGIN_PAGE_PATH)}
            redirect_uri={redirectUri}
            scope={authService.getScopes()}
          >
            <Switch>
              <Redirect from={INDEX_PAGE_PATH_REDIRECT} to={HOME_PAGE_PATH} />
              <Route path={LOGIN_PAGE_PATH} render={() => <LoginPage appServiceWorker={appSW} />} />
              <PrivateRoute path="/layout-template-1" render={() => <LayoutTemplate1 />} />
              <PrivateRoute path="/layout-template-2" render={() => <LayoutTemplate2 />} />
              <PrivateRoute path="/layout-template-3" render={() => <LayoutTemplate3 />} />
              <PrivateRoute exact path={HOME_PAGE_PATH} render={() => <DashboardPage />} />
              <PrivateRoute path={LOGOUT_PAGE_PATH} render={() => <LogoutPage />} />
              <Redirect from={ORDER_CONCRETE_DELIVERIES_PLURAL_PAGE_REDIRECT} to={ORDER_CONCRETE_DELIVERIES_PAGE_PATH} />
              <Redirect from={ORDER_PLURAL_PAGE_REDIRECT} to={ORDER_PAGE_PATH} />
              <PrivateRoute path={ORDER_CONCRETE_DELIVERIES_PAGE_PATH} render={({ match }) => <OrderConcreteDeliveriesPage orderId={match.params.orderId} />} />
              <PrivateRoute path={ORDER_PAGE_PATH} render={({ match }) => <OrderPage orderId={match.params.orderId} />} />
              <PrivateRoute path={ACCOUNTS_PAGE_PATH} render={() => <AccountsPage />} />
              <PrivateRoute path={REPORTS_PAGE_PATH} render={() => <ReportsPage />} />
              <PrivateRoute path={REPORT_PAGE_PATH} render={({ match }) => <ReportPage reportType={match.params.reportType} />} />
              <PrivateRoute path={ACCOUNT_PAGE_PATH} render={({ match }) => <AccountPage accountId={match.params.accountId} />} />
              <PrivateRoute path={ORDERS_PAGE_PATH} render={() => <OrdersPage />} />
              <PrivateRoute path={DOCKETS_PAGE_PATH} render={({ match }) => <DocketsPage orderId={match.params.orderId} />} />
              <PrivateRoute path={PLACE_ORDER_PAGE_PATH} render={() => <PlaceOrderPage />} />
              <PrivateRoute path={SETTINGS_PAGE_PATH} render={() => <SettingsPage />} />
              <PrivateRoute path={PROFILE_PAGE_PATH} render={() => <ProfilePage />} />
              <Route path={HELP_PAGE_PATH} render={() => <HelpPage />} />
              <Route path={TERMS_CONDITIONS_PAGE_PATH} render={() => <TermsPage />} />
              <Route path="/implicit/callback" render={() => <ImplicitCallback />} />
              <Route path={ERROR_PAGE_PATH} render={() => <ErrorPage status={httpStatus.INTERNAL_SERVER_ERROR} />} />
              <Route render={() => <ErrorPage status={httpStatus.NOT_FOUND} />} />
            </Switch>
          </Security>
        </Router>
      </MuiPickersUtilsProvider>
    );
  }

  /**
   * Render PortalCustomerEntryComponent
   * @returns {React.Component} PortalCustomerEntryComponent
   * @memberof PortalCustomerEntryComponent
   */
  render() {
    return (
      <App entry={portalCustomerEntry} history={browserHistory} services={portalCustomerServices}>
        <Router history={browserHistory}>
          <Switch>
            <PrivateRoute path={ADMIN_PAGE_PATH} render={this.renderAdminRoutes} />
            <Route render={() => this.renderOktaRoutes()} />
          </Switch>
        </Router>
      </App>
    );
  }
}

/** @type {React.ComponentClass<PortalCustomerEntryComponentProps>} */
const PortalCustomerEntry = compose(withStyles(themeCreateInjectableStyles({}), { withTheme: true }))(PortalCustomerEntryComponent);

export default PortalCustomerEntry;
